import React from "react";
import { toast } from "react-toastify";


interface IPROPS {
  closeModal: (success?: boolean) => void;
  fieldsData: any;
  refetch: any;
  deleteMultiLevelFieldsLabel: any;
  fieldData: any;
  handleUpdate: (updated: any) => void;

}
const DeleteLabelModal: React.FC<IPROPS> = ({
  closeModal,
  fieldsData,
  refetch,
  deleteMultiLevelFieldsLabel,
  fieldData,
  handleUpdate

}) => {

  const deleteFieldHandler = async () => {
    const rootNode = {
      id: String(fieldsData.parentId),
      level: String(fieldsData.level),
    };
    try {
      const response = await deleteMultiLevelFieldsLabel(rootNode).unwrap();
      console.log(response.message, "responseee");

      if (typeof refetch === 'function') {
        await refetch();
        closeModal(true);
      }
      if (response?.message) {
        toast.success(response?.message);
        refetch();
      } else {
        toast.error("Unable to delete");
      }
    } catch (error) {
      toast.error("An error occured");
    }
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "end",
        }}
      >
        <i
          style={{
            fontSize: "26px",
            color: "black",
            cursor: "pointer",
          }}
          className="bi bi-x"
          onClick={() => closeModal(true)}
        ></i>
      </div>
      <div style={{ color: "#3071e4", fontSize: "16px" }}>
        Are you sure?
      </div>
      <div style={{ marginBottom: "15px" }}>
        Do you really want to delete these records? This process cannot
        be undone.
      </div>
      <div style={{ display: "flex", gap: "10px" }}>
        <button className="btn btn-danger" onClick={deleteFieldHandler}>
          Delete
        </button>
        <button
          className="btn btn-light"
          onClick={() => closeModal(true)}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default DeleteLabelModal;